import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllArticulos } from "../../../redux/articulos/articulosAction";
import Select from 'react-select';
import { customStylesMod } from "./selectCss";

export default function ArticulosMod({index, articuloIn, onDelete, onArticuloChange}){
    const dispatch = useDispatch();
    const articulos = useSelector(state => state.articulos.allArticulos)
    // const [articulo, setArticulo] = useState({
    //     id: "",
    //     codArticulo:"",
    //     nombre:"",
    //     ciclo:"",
    //     isbn:"",
    //     cantidad:"",
    //     precio: "",
    //     precioTotal: ""
    // });
    const [articulo, setArticulo] = useState(articuloIn);
    //console.log(articuloIn);
    
       
    useEffect(() => {
        dispatch(getAllArticulos())
    }, [dispatch]);    

    
    const options = [
        {value:"", label:"Select...", codArticulo:"Select..."},
        ...articulos.map(e => ({
        label: `${e.codArticulo} - ${e.nombre}`,
        value: e._id,
        codArticulo: e.codArticulo 
      }))
    ];

    const CustomDropdownIndicator = () => null; //saca la flecha del select

    
    const findArticulo = (e) => {
        console.log(e);        
        const foundArticulo = articulos.find(x => x._id === e.value)        
        //console.log(foundArticulo);  
        // console.log(foundArticulo.nombre);
        
        
        if(foundArticulo){
        setArticulo({
            ...articulo,
            id: foundArticulo._id,
            codArticulo: foundArticulo.codArticulo,
            nombre: foundArticulo.nombre,
            ciclo: foundArticulo.ciclo,
            isbn: foundArticulo.isbn,
            precio: foundArticulo.precio,
            cantidad: "",
            precioTotal: ""
        })  
      } else {
        setArticulo({
            id: "",
            codArticulo:"",
            nombre:"",
            ciclo:"",
            isbn:"",
            cantidad:"",
            precio: "",
            precioTotal: ""
        })
      }
    }
    
    const handleCantidad = (e) => {
        const { value } = e.target;
        setArticulo({
          ...articulo,
          cantidad: value,
          //precioTotal: articulo.precio * value,
        });       
      };

    const handleKey = (e) => {
        const {value} = e.target
        if(e.key === 'Enter'){            
            const updatedArticulo = {
                ...articulo,
                precioTotal: parseFloat(articulo.precio) * articulo.cantidad
            }
            //console.log(updatedArticulo);
            

            setArticulo(updatedArticulo)
            onArticuloChange(updatedArticulo) 
        }
    }

    return (
        <>  
        <div className="w-[1180px] border text-[10pt] font-bold">           
            <table>               
                <tbody>
                    <tr>
                        <td>
                            <div className='w-[78px]'>                           
                            <Select                           
                                styles={customStylesMod()}
                                value={options.find(option => option.value === articulo.id)}   
                                onChange={findArticulo}                                
                                options={options}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                formatOptionLabel={(option, { context }) => context === 'menu' ? option.label : option.codArticulo}
                                components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: null }}    
                                //isClearable={true}                            
                            />
                            </div>
                        </td>
                        <td className="w-[600px] pl-1 border">
                            {articulo.nombre ? articulo.nombre : "nombre"}
                        </td>
                        <td className="w-[120px] pl-1 text-center border">{articulo.ciclo ? articulo.ciclo : "ciclo"}</td>
                        <td className="w-[135px] text-center border">{articulo.isbn ? articulo.isbn : "isbn"}</td>
                        <td className="w-[80px] border">
                            <input 
                                className="w-[76px] text-right"
                                type="number"
                                value={articulo.cantidad}
                                onChange={handleCantidad}
                                onKeyUp={handleKey}
                            />
                        </td>
                        <td className="w-[80px] pr-1 text-right border">{articulo.precio ? articulo.precio : null}</td>
                        <td className="w-[80px] pr-1 text-right border">{articulo.precioTotal ? articulo.precioTotal : null}</td>
                        <td><button onClick={onDelete}>Eliminar</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
        </>
    )
}